import { render, staticRenderFns } from "./SimpleBarChart.vue?vue&type=template&id=08198300&"
import script from "./SimpleBarChart.vue?vue&type=script&lang=js&"
export * from "./SimpleBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports